import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import PriceInput from "../../../components/custom/CustomInputs/PriceInput";
import { useTranslation } from "react-i18next";

export const ReservePriceInput = ({ formik }) => {

  const { t } = useTranslation(`carEstimateAuction`);

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Typography gutterBottom>
        {t(`Reserve Price.label`)}
      </Typography>

      <PriceInput 
        name="reservePrice"
        value={formik.values.reservePrice}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.reservePrice && Boolean(formik.errors.reservePrice)
        }
        helperText={formik.touched.reservePrice && formik.errors.reservePrice}
        fullWidth
        sx={{ mb: 3 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Typography>$</Typography>
            </InputAdornment>
          ),
        }}
      />

      {/* <TextField
        name="reservePrice"
        value={formik.values.reservePrice}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.reservePrice && Boolean(formik.errors.reservePrice)
        }
        helperText={formik.touched.reservePrice && formik.errors.reservePrice}
        fullWidth
        sx={{ mb: 3 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Typography>$</Typography>
            </InputAdornment>
          ),
        }}
      /> */}
    </Box>
  );
};
